import { redirect } from 'react-router-dom';
import clientApi from '~/clientApi';

export function openExternalUrl(url: string): void {
    clientApi.openExternalUrl(url) || redirect(url);
}
